import type { Theme } from '@emotion/react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const componentConfig = (theme: Theme) => ({
  size: theme.eclipseTier1.sizing['16px'],
  borderWidth: 3,
});

type SpinnerIconProps = {
  size?: number;
};

const rotateSpinner = keyframes({
  to: {
    transform: 'rotate(360deg)',
  },
});

const SpinnerIcon = styled.div<SpinnerIconProps>(({ theme, size }) => {
  const { size: defaultSize, borderWidth } = componentConfig(theme);
  const _size = size || defaultSize;

  return {
    display: 'flex',
    justifyContent: 'center',
    ':focus-visible': { outline: 0 },
    '::after': {
      animation: `${rotateSpinner} 1s linear infinite`,
      display: 'flex',
      content: '""',
      width: _size,
      height: _size,
      borderRadius: theme.eclipseTier1.radius['9999px'],
      background: `conic-gradient(from 0deg, transparent 0%, ${theme.eclipseTier2Color.text.brand.default} 100%)`,
      mask: `radial-gradient(farthest-side, transparent calc(100% - ${borderWidth}px), #000 calc(100% - ${borderWidth}px))`,
    },
  };
});

export const S = { SpinnerIcon } as const;
